import * as c from "react";
const t = (e) => /* @__PURE__ */ c.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ c.createElement(
    "path",
    {
      d: "M17.422 15.504c0 .742-.189 1.35-.567 1.821-.377.472-.856.83-1.435 1.074a6.838 6.838 0 01-1.7.484c-.553.078-1.087.117-1.6.117H5.478v-.898c.566 0 .984-.059 1.254-.176.27-.117.446-.283.528-.498.081-.215.122-.511.122-.889V8.18c0-.585-.12-.992-.362-1.22-.24-.228-.755-.342-1.542-.342V5.7l2.695-.058c.853-.02 1.554-.035 2.104-.044.55-.01.936-.015 1.157-.015h.362c.677 0 1.385.07 2.124.21.739.14 1.413.457 2.021.952.61.495.913 1.208.913 2.139 0 .696-.247 1.295-.742 1.797-.495.501-1.305.914-2.431 1.24.768.137 1.437.366 2.006.688.57.323 1.001.731 1.294 1.226.293.495.44 1.051.44 1.67zm-3.36-6.543c0-.456-.108-.855-.327-1.196-.218-.342-.54-.61-.966-.801-.427-.192-.95-.288-1.568-.288h-1.025v4.746h.8c1.049 0 1.825-.222 2.33-.664.504-.443.757-1.042.757-1.797zm.362 6.377c0-.899-.233-1.597-.698-2.095-.466-.498-1.122-.747-1.968-.747h-1.582v3.447c0 .482.03.858.088 1.128.058.27.205.479.44.625.233.147.605.22 1.112.22.677 0 1.281-.205 1.812-.615.53-.41.796-1.065.796-1.963z",
      fill: "#2d6ded"
    }
  )
), l = t;
export {
  l as default
};
